import { Badge, Button } from "@material-ui/core";
import React from "react";

interface ItemsCountProps {
  count: number;
  onClick: () => void;
  color: string;
}

const ItemsCount = ({ count, onClick, color }: ItemsCountProps) => (
  <Button
    onClick={onClick}
    startIcon={<Badge color="primary" />}
    style={{ marginTop: -10, height: 30, width: 90, fontSize: 10, borderColor: color }}
    variant="outlined"
  >
    <label style={{ fontSize: 11, color: color }}>{`${count} Article${count > 1 ? "s" : ""}`}</label>
  </Button>
);

export default ItemsCount;
